import { render, staticRenderFns } from "./BroadcastsEdit.vue?vue&type=template&id=4a593ca0&"
import script from "./BroadcastsEdit.vue?vue&type=script&lang=ts&"
export * from "./BroadcastsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports